export const listTefTypes = [
  { textCredential: 'Todos', valueCredential: '999' },
  { textCredential: 'Datafast PinPad', valueCredential: '1' },
  { textCredential: 'Medianet PinPad', valueCredential: '2' },
]
